import React from "react";
import { ChevronDown } from "lucide-react";
import { CoinIcon } from "./CoinIcon";

export function UpDownToolbar({
  pairTriggerRef,
  isPairListOpen,
  setIsPairListOpen,
  selectedPair,
  marketSymbol,
  activePairOption,
  symbol,
  activePairStats,
  wallet,
  dynamicPayoutPercent,
  mobileChartIntervalButtons,
  chartControls,
  chartTypeButtons,
  playSound,
}) {
  const currentPairSymbol =
    selectedPair ??
    marketSymbol ??
    activePairOption?.label ??
    symbol;

  const currentPairLabel = activePairOption?.label ?? symbol;

  const changePercent = Number(
    activePairStats?.changePercent ??
      activePairOption?.change24h ??
      0,
  );

  const profitDisplay = wallet?.binary?.win_percentage || dynamicPayoutPercent;

  return (
    <section>
      <div className="updown-toolbar--compact flex items-center justify-between gap-2 px-1 py-1 mb-1.5 min-w-0">
        <div className="updown-toolbar__left !flex !items-center !flex-nowrap gap-2 min-w-0">
          <div className="md:hidden shrink-0">
            {mobileChartIntervalButtons}
          </div>
          <div className="updown-pair-select-wrap !w-auto min-w-0">
            <button
              ref={pairTriggerRef}
              type="button"
              className={`updown-pair-select ${isPairListOpen ? "is-open" : ""}`}
              onClick={() => {
                if (typeof playSound === "function") playSound("button");
                setIsPairListOpen(true);
              }}
              aria-label="Open top Binance pairs"
            >
              <span
                className="updown-pair-select__icon"
                aria-hidden="true"
              >
                <CoinIcon symbol={currentPairSymbol} />
              </span>
              <span className="updown-pair-select__body">
                <strong>{currentPairLabel}</strong>
                <small
                  className={changePercent >= 0 ? "is-up" : "is-down"}
                >
                  {changePercent >= 0 ? "+" : ""}
                  {changePercent.toFixed(2)}%
                </small>
              </span>
              <ChevronDown
                size={14}
                className="updown-pair-select__caret"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>

        <div className="md:hidden shrink-0">
          <div className="updown-profit-badge">
            <span className="updown-profit-badge__label">Profit:</span>
            <span className="updown-profit-badge__val">
              {profitDisplay}%
            </span>
          </div>
        </div>
      </div>

      <div>
        <div className="hidden md:block">
          <div className="flex justify-between items-center mb-2 mt-2 px-2">
            {chartControls}
            <div className="updown-profit-badge">
              <span className="updown-profit-badge__label">Profit:</span>
              <span className="updown-profit-badge__val">
                {profitDisplay}%
              </span>
            </div>
          </div>
        </div>
        {chartTypeButtons && (
          <div className="md:hidden mb-1 px-1">
            <div className="updown-chart-controls !mt-0 flex items-center gap-1.5">
              {chartTypeButtons}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

